import { useState } from "react";
import ToastMsg from "components/common/ToastMsg";
import useApiMethods from "hooks/apiConfig/method/apiMethods";

const useExportData = () => {
    const { fetch } = useApiMethods();
    const [loading, setLoading] = useState(false);

    const getPrintData = async (url, query) => {
        try {
            setLoading(true);
            const exportUrl = `${url}${query}&export_type=pdf`;
            
            const response = await fetch(exportUrl, {}, setLoading);
            
            const fileBlob = new Blob([response], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(fileBlob);
            window.open(fileURL);
            
        } catch (error) {
            ToastMsg("error", error.message || "Failed to export PDF.");
        } finally {
            setLoading(false);
        }
    };

    const getCSVData = async (url, query, type = 'csv') => {
        try {
            setLoading(true);
            const exportUrl = `${url}${query}&export_type=${type === 'xlsx' ? "xlsx" : "csv"}`;            
            
            const response = await fetch(exportUrl, {}, setLoading);
            
            const blobData = new Blob([response], {
                type: type === "xlsx"
                    ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    : "text/csv"
            });

            const csvURL = URL.createObjectURL(blobData);
            
            const currentDate = new Date().toISOString().replace(/[-T:.Z]/g, "");
            const fileName = `Export_${currentDate}.${type}`;
            
            const link = document.createElement("a");
            link.href = csvURL;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
        } catch (error) {
            ToastMsg("error", error.message || "Failed to export CSV.");
        } finally {
            setLoading(false);
        }
    };

    const downloadPDF = (url) => {
        const link = document.createElement('a');
        link.href = url;
        link.target = "_blank"
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().slice(0, 19).replace(/[-T]/g, '').replace(/:/g, '');
        link.setAttribute('download', `${formattedDate}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return { getPrintData, getCSVData, downloadPDF, loading };
};

export default useExportData;
